import { TrendingUp, Shield, Brain, Globe, Users } from "lucide-react";

const features = [
  { icon: TrendingUp, text: "Trading and market understanding (crypto, forex, digital assets)" },
  { icon: Shield, text: "Structured decision-making and risk awareness" },
  { icon: Brain, text: "AI literacy for modern trading tools" },
  { icon: Globe, text: "Web3 fundamentals and ecosystem context" },
  { icon: Users, text: "Community standards built on responsibility and long-term thinking" },
];

const WhatItIs = () => {
  return (
    <section data-testid="what-it-is-section" className="section-primary">
      <div className="section-glow top-left"></div>
      <div className="section-glow bottom-right"></div>
      
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">A Neutral Education & Collaboration Community</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            FLEXX Academy operates as an independent, education-first community designed to support:
          </p>
        </div>
        
        <div className="feature-list">
          {features.map((feature, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon">
                <feature.icon />
              </div>
              <p className="feature-text">{feature.text}</p>
            </div>
          ))}
        </div>
        
        <p className="gold-statement" style={{ textAlign: 'center' }}>
          Platform-agnostic. Collaboration-ready.
        </p>
      </div>
    </section>
  );
};

export default WhatItIs;
